import { render, staticRenderFns } from "./SkuSale.vue?vue&type=template&id=553aec5a&scoped=true&"
import script from "./SkuSale.vue?vue&type=script&lang=js&"
export * from "./SkuSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553aec5a",
  null
  
)

export default component.exports